export default __webpack_public_path__ + "static/10-d5a47bde85dbe487d96d06288387962f.jpg";